import useOrigin from '@/helper/useOrigin.js';

export default class ProviderPosts {
  constructor (provider, route) {
    this.provider = provider;
    this.existingProviders = ['SYNOT', 'ENDORPHINA', 'PLAYNGO', 'TECH4BET', 'BFGAMES', 'CTINTERACTIVE', 'YGGDRASIL', 'NOVOMATIC', 'TOMHORN'];
    this.isSupported = this.existingProviders.includes(provider);
    this.regulatoryWrapper = null;
    this.route = route;
    this.origin = '*';
  }

  setWrapperPointerEvents (pointerEvent = 'auto') {
    if (!this.regulatoryWrapper) {
      try {
        this.regulatoryWrapper = document.getElementById('cz-regulatory-wrapper-slot');
        this.regulatoryWrapper.style.pointerEvents = pointerEvent;
        return;
      }
      catch { return setTimeout(this.setWrapperPointerEvents.bind(this, pointerEvent), 500); }
    }

    this.regulatoryWrapper.style.pointerEvents = pointerEvent;
  }

  setProviderGameState (activate = true) {
    let data = '';
    if (this.isSupported) {
      const iframeId = this.provider === 'TOMHORN' ? 'casinoClient' : 'IFRAME';
      try {
        const iframeRef = document.getElementById(iframeId);
        data = this[`${this.provider}Post`](activate);
        iframeRef.contentWindow.postMessage(data, this.origin);
      } catch {
        return setTimeout(this.setProviderGameState.bind(this, activate), 500);
      }
    }

    this.setWrapperPointerEvents(activate ? 'auto' : 'none');
  }

  SYNOTPost (activate) {
    return { event: activate ? 'p2g.gamePlayResume' : 'p2g.gamePlayDisable' };
  }

  ENDORPHINAPost (activate) {
    return { messageId: activate ? 'unblockGame' : 'blockGame' };
  }

  TECH4BETPost (activate) {
    return activate ? '' : { method: 'gel.autoPlay.stop' };
  }

  BFGAMESPost (activate) {
    return activate ? '' : { 'bf:request_action': 'stop_autoplay' };
  }

  CTINTERACTIVEPost (activate) {
    return activate ? '' : { name: 'stopAutospins' };
  }

  PLAYNGOPost (activate) {
    if(this.origin === '*') this.origin = useOrigin(this.route.query.gameURL);
    return { messageType: 'request', request: activate ? 'gameEnable' : 'gameDisable' };
  }

  YGGDRASILPost(activate) {
    return activate ? 'game/resume' : 'game/pause';
  }

  NOVOMATICPost(activate) {
    let data = activate ? '' : { action: { name: 'autoplayOff' } };
    data = JSON.stringify(data);
    return data
  }

  TOMHORNPost(activate) {
    return activate ? '' : 'doGameSuspend';
  }
}
